import React from 'react'

import { css } from '@emotion/css';
import { ButtonOrangeAds } from '../Button/Button';

function EcommerceAds(props) {
    return (
        <div className={css`
        position:fixed;
        width:100%;
        z-index:100;
        padding:10px 20px;
        bottom:0;
        left:0;

        display:flex;
        align-items:center;
        justify-content: center;

        background: #ffffeebd;
        backdrop-filter: blur(10px);
        `}>
            <small className={css`
            color:grey;
            margin-right: 12px;
            font-size: 11px;
            `}>
                This website is sponsored by Ecommerce site, please considering click / purchase to support the developers.
            </small>

            <ButtonOrangeAds href={`https://shopee.co.id/search?keyword=boneka%20${props.name}`}>
                Beli boneka <span className={css`color:#fff725; font-weight:bold`}>{props.name}</span> sekarang!!
            </ButtonOrangeAds>


        </div>
    )
}


export default EcommerceAds

